import React from 'react';

import styled from 'styled-components';

import MountSinaiLogo from '../assets/img/mount_sinai_logo.png'
import AlbanyLogo from '../assets/img/albany_logo_2.png'
import MVPLogo from '../assets/img/mvp_logo.png'
import JPMLogo from '../assets/img/JP-Morgan-Chase-Logo.png'
import GoogleLogo from '../assets/img/Google-Logo.png'
import ExperienceItem from './ExperienceComponent/ExperienceItem';

const Container = styled.div`
overflow:hidden;
h1 {
    text-align: center;
}
hr {
    margin-bottom: 55px;
}
`

const experienceData = [
    {
        company: "Google",
        from: "August 2022",
        to: "Present",
        title: "Software Engineer",
        logo: GoogleLogo,
        bullets: ["Increased billing support case deflection in Google Cloud by 30% through leading the end-to-end development of a Gen AI concierge service from initial design to global launch, integrating context based grounding for RAG, user signals embeddings in prompts and instructions, multi-agent architectures, and function calling for real-time API data access.",
            "Secured 10,000+ daily AI conversations by pioneering a safety framework featuring PII pre-processing filters and LLM post-processing harmful content detection.",
            "Enabled Gen AI analytics for 5+ cross-functional teams by architecting a centralized data pipeline currently leveraged by 30+ power users for research and reporting."],
        translate: [300, 0]
    },
    {
        company: "JPMorgan Chase",
        from: "October 2021",
        to: "July 2022",
        title: "Software Engineer",
        logo: JPMLogo,
        bullets: ["Enhanced account security for 50M+ consumer banking users by developing backend Java microservices for fraud detection and 2FA, improving the catch rate for malicious activity across 20+ RESTful authentication flows.",
            "Mitigated production risks for sensitive banking data by achieving near 100% code coverage through TDD (JUnit) and BDD (Cucumber) testing frameworks, ensuring zero post-deployment defects in authentication logic.",
            "Supported authentication processes generating 100+ million monthly calls by managing production deployments, launching server pools, and creating global load balancers."],
        translate: [-300, 0]
    },
    {
        company: "Mount Sinai Health System",
        from: "August 2020",
        to: "October 2021",
        title: "Research Programmer Analyst",
        logo: MountSinaiLogo,
        bullets: ["Expanded platform capacity and user adoption to support 70+ research projects and 250+ researchers by leading the full-stack architectural design and end-to-end development of a proprietary medical research e-consent platform.",
            "Reduced medical e-consent procedure times by 66% for thousands of users by implementing DocuSign integration, multi-language support, and a researcher-facing management dashboard which allowed for batch importing patients.",
            "Optimized platform stability and deployment speed while maintaining 24/7 availability across 3 production servers by streamlining the continuous delivery process and architecting new data pipelines."],
        translate: [300, 0]
    },
    {
        company: "UAlbany Data Mining Lab",
        from: "January 2020",
        to: "May 2020",
        title: "Research Project Software Engineer",
        logo: AlbanyLogo,
        bullets: ["Pioneered an independent full stack development project to build a user-friendly activity monitor for a location based mobile app to increase productivity through data visualization on a map with 100+ possible combinations for data analysis.",
            "Designed a REST API and login server using a MySQL database and the Express Node.js framework with 5+ routes in each.",
            "Constructed the activity monitor website featuring user authentication, user roles, an administrator panel, data analytics, and an interactive map generated with 7 user inputted parameters, built with Angular 8 and the Google Maps API."],
        translate: [-300, 0]
    },
    {
        company: "MVP Health Care",
        from: "June 2019",
        to: "August 2019",
        title: "Software Engineer Intern",
        logo: MVPLogo,
        bullets: ["Engineered 15 interactive SSRS reports for the operations department in an Agile Scrum development cycle, exceeding the department’s goal by 10+ reports for the summer.",
            "Produced 100+ queries, functions, stored procedures, and tables to develop new reports and improve existing reports.",
            "Reviewed, tested, and debugged new code and over 10 projects of legacy code.",
            "Led presentations for executive team to elucidate 100,000+ rows of errors in database to ensure reliability of data."],
        translate: [300, 0]
    }
]
const Experience = () => {

    return (
        <Container id="experience">
            <h1>Experience</h1>
            <hr />
            {experienceData
                .map((job, index) => (
                    <ExperienceItem key={index} job={job}/>
                ))}
        </Container>
    );
};

export default Experience;